import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './Menu.css';
import React from 'react';
import images from '../../constants/images';
import { useLanguage } from '../../constants/localisations/language_context';
import data_eng from '../../constants/data_eng';
import data_sv from '../../constants/data';
import { LANG_ENG, LANG_SV } from '../../constants/strings';

// The login/logout entry is hidden (see the commented-out 'Logga in' item in
// src/constants/data.js). The Login/Logout routes and files are still there, they
// are just unlinked — so Menu no longer loads firebase/auth to track login state.
const Menu = () => {
    const { currentLanguage, changeLanguage } = useLanguage();
    const menuData = currentLanguage === LANG_ENG ? data_eng : data_sv;

    const handleLanguage = (language) => {
        changeLanguage(language);
    };

    return (
        <Navbar collapseOnSelect expand="lg" bg="ligth" variant="ligth">
            <Container>
                <Navbar.Brand href="/"> 
                <img
        src={images.logo}
        width="100" // Adjust width as needed
        height="100" // Adjust height as needed
        className="d-inline-block align-top" // Keeps the logo aligned properly
        alt="Techlära Logo"
        title="Techlära Logo"
    />
                </Navbar.Brand>
                
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
                    <Nav>
                        {menuData.Menu.map((item, index) => {
                            if (item.id === 'language') {
                                return (
                                    <div key={`menu-${index}`} className="btn-language-container">
                                        <button className={`btn-language ${currentLanguage === LANG_ENG ? 'btn-language-selected' : ''}`} onClick={() => handleLanguage(LANG_ENG)}>🇬🇧</button>
                                        <button className={`btn-language ${currentLanguage === LANG_SV ? 'btn-language-selected' : ''}`} onClick={() => handleLanguage(LANG_SV)}>🇸🇪</button>
                                    </div>
                                );
                            }
                            
                            return (
                                <Nav.Link key={`menu-${index}`} href={item.link}>
                                    {item.text}
                                </Nav.Link>
                            );
                        })}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default Menu